class Insert {
    constructor(model) {
        this.model = model;
    }

    toString() {
        return `insert for ${this.model.id}`;
    }
}

class Update {
    constructor(model) {
        this.model = model;
    }

    toString() {
        return `update for ${this.model.id}`;
    }
}

class Delete {
    constructor(model) {
        this.model = model;
    }

    toString() {
        return `delete for ${this.model.id}`;
    }
}

export { Insert, Update, Delete };


// WEBPACK FOOTER //
// ./src/js/service/live.js